<template>
    <div class="col-12 pb-5 mb-4">
        <div class="row no-gutters">
            <div class="col-lg-3 middle-background"></div>
            <div class="col-md-12 col-lg-6 middle-background">
                <div class="row">
                    <br />
                </div>
                <div class="row no-gutters mt-5">
                    <div class="col-lg-12">
                        <div class="row">
                            <br />
                        </div>
                        <div class="d-flex justify-content-center">
                            <div class="pt-lg-5 mt-4">
                                <!-- <img class="img-fluid" src="../assets/No_Internet.svg" > -->
                                <img class="img-fluid nointernet" alt="nointernet">
                            </div>
                            
                        </div>
                        <div class="d-flex justify-content-center pt-3">
                            <span class="oops proximanova">No Internet Connection</span>
                            <!-- <span>Make sure Wi-Fi or mobile data is turned on, then try again.</span> -->
                        </div>
                        <div class="d-flex justify-content-center p-2">
                            <!-- <span class="oops">No Internet Connection</span> -->
                            <span class="font24-opacity60 proximanova pb-lg-5 pb-3">Make sure Wi-Fi or mobile data is turned on, then try again.</span>
                        </div>
                        <div class="line"></div>
                        <div class="d-flex justify-content-center p-2 pt-4">
                            <button class="btn button-cancel1" @click = "close">
                                <span class="proximanova">Retry</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            nointernet : true
        }
    },
    methods:{
        close() {
            this.$emit('close');
        },
    }
}
</script>
<style scoped>
.font32-bold{
	color: #1F1F1F;
	font-family: "Proxima Nova";
	font-size: 30px;
    font-weight: bold;
  }
  .font24-opacity60 {
	font-family: 'Proxima Nova Regular';
	font-size: 24px;
	color: rgba(31,31,31,.6);
    }
    .line {
  box-sizing: border-box;
  height: 1px;
  width: 240px;
  border: 1px solid #1F1F1F;
  opacity: 0.3;
  margin: 0 auto;
}
.nointernet {
    content : url("../assets/No_Internet.svg")
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 20px;
  /* transition: border 8s; */
}
.button-cancel1{
  opacity: 1;
  /* color: yellow; */
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
  -webkit-background-clip: text;
-webkit-text-fill-color: transparent;
  border: 2px solid transparent;
  border-radius: 10px !important;
  -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
  border-image-slice: 1;
}

</style>
